import styled from 'styled-components';

const AddAssetSelectorDrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme: { token } }) => token.padding}px;
  gap: ${({ theme: { token } }) => token.marginLG}px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .header-title {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading4}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.margin}px;

    .body-title {
      color: ${({ theme: { token } }) => token.colorTextDescription};
    }

    .assets {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: ${({ theme: { token } }) => token.marginSM}px ${({ theme: { token } }) => token.margin}px;
    }
  }
`;

export default AddAssetSelectorDrawerContainer;
